// src/pages/Weddings/steps/Payment/WeddingPaymentForm.jsx
import React, { useState } from "react";
import { Box, Button, Alert } from "@mui/material";
import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import api from "../services/api";

export default function WeddingPaymentForm({ orderId, onClose, onSuccess }) {
  const stripe = useStripe();
  const elements = useElements();
  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg] = useState(null);

  const applyPIToOrder = async (piId) => {
    try {
      // tiny endpoint you added server-side:
      // POST /weddings/orders/:orderId/apply-payment-intent { paymentIntentId }
      await api.post(`/weddings/orders/${orderId}/apply-payment-intent`, {
        paymentIntentId: piId,
      });
    } catch (e) {
      // Non-fatal for the user; webhook will still reconcile. Log for us.
      console.warn("apply-payment-intent failed (will rely on webhook):", e);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setSubmitting(true);
    setMsg(null);

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      redirect: "if_required",
    });

    if (error) {
      setMsg(error.message || "Payment failed. Please try again.");
      setSubmitting(false);
      return;
    }

    // Tell the server right away (even if 'processing'—the server can fetch fresh state from Stripe)
    if (paymentIntent?.id) {
      await applyPIToOrder(paymentIntent.id);
    }

    if (paymentIntent?.status === "succeeded") {
      setMsg("Payment succeeded! 🎉");
      try {
        onSuccess && onSuccess(paymentIntent);
      } finally {
        setTimeout(() => onClose && onClose(), 600);
      }
      return;
    }

    // Other statuses (e.g., 'processing', 'requires_action')—UI message + let webhook catch up
    setMsg(`Payment status: ${paymentIntent?.status || "unknown"}`);
    setSubmitting(false);
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      {msg && (
        <Alert
          severity={msg.startsWith("Payment succeeded") ? "success" : "info"}
          sx={{ mt: 2 }}>
          {msg}
        </Alert>
      )}
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, gap: 1 }}>
        <Button variant="text" onClick={onClose} disabled={submitting}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          disabled={!stripe || submitting}>
          {submitting ? "Processing…" : "Pay now"}
        </Button>
      </Box>
    </form>
  );
}
